module.exports = __webpack_public_path__ + "img/logo-installment-UOB.4fba8715.png";